import { GatewayControleQuinquennal } from "@conformite/gateway";
import {
  InputWysiwyg,
  FileInputButtonWithDrag,
  Form,
  useFormConfig,
  Button,
  FormField,
  FormGrid,
  FormRow,
} from "@endya-conformite/ui-kit";
import TrashIcon from "@endya-conformite/ui-kit/src/assets/icons/trash.svg?react";
import { zod } from "@endya-conformite/ui-kit/src/lya/exports";
import { useCallback } from "react";
import style from "./ControleQuinquennalRemediationForm.module.scss";

const schema = zod.object({
  files: zod.array(
    zod.object({
      idFile: zod.string().optional(),
      file: zod.instanceof(File).optional(),
      pathname: zod.string(),
      filename: zod.string(),
    })
  ),
  description: zod
    .string()
    .refine((v) => v.replace(/<[^>]*>/g, "").length > 0, {
      message: "Champs obligatoire",
    }),
});
export type RemediationFormValues = zod.infer<typeof schema>;
type RemediationFormValueFile = RemediationFormValues["files"][0];

type RemediationFormProps = {
  onSubmit: (values: RemediationFormValues) => unknown;
  formId: string;
  defaultValue?: GatewayControleQuinquennal.ControleQuinquenalRemediationResponseType;
};

export function ControleQuinquennalRemediationForm({
  onSubmit,
  formId,
  defaultValue,
}: RemediationFormProps) {
  const formConfig = useFormConfig<typeof schema, RemediationFormValues>({
    schema,
    defaultValues: {
      files: [],
      description: defaultValue?.description ?? "",
      ...defaultValue,
    },
  });

  const handleAddFile = useCallback(
    (file: File[]) => {
      if (file.length === 0) return;
      formConfig.setValue("files", [
        ...formConfig.getValues().files,
        ...file.map((f) => ({
          file: f,
          filename: f.name,
          pathname: crypto.randomUUID(),
        })),
      ]);
    },
    [formConfig]
  );

  const handleRemoveFile = useCallback(
    (file: RemediationFormValueFile) => () => {
      formConfig.setValue(
        "files",
        formConfig.getValues("files").filter((fileCheck) => file !== fileCheck)
      );
    },
    [formConfig]
  );

  const files = formConfig.watch("files");

  return (
    <Form
      id={formId}
      formConfig={formConfig}
      onSubmit={(payload) => {
        onSubmit(payload);
      }}
    >
      <FormGrid disableHorizontalGutter>
        <FormRow>
          <FormField>
            <InputWysiwyg name="description" />
          </FormField>
        </FormRow>

        <FormRow>
          <FormField>
            <div className={style.files}>
              {files?.map((file) => (
                <div key={file.pathname} className={style.file}>
                  <p>{file.filename}</p>
                  <Button
                    variant="text"
                    icon={<TrashIcon />}
                    onClick={handleRemoveFile(file)}
                  />
                </div>
              ))}
            </div>
          </FormField>
        </FormRow>
        <FormRow>
          <FormField>
            <FileInputButtonWithDrag
              variant="input"
              onChange={handleAddFile}
              multiple
            >
              <p>Ajouter une pièce jointe</p>
            </FileInputButtonWithDrag>
          </FormField>
        </FormRow>
      </FormGrid>
    </Form>
  );
}
